<script setup>
import IOrderSubscribeItem from "../IOrderSubscribeItem/IOrderSubscribeItem.vue";
import IOrderEventItem from "../IOrderEventItem/IOrderEventItem.vue";

const props = defineProps({
	itemCase: {
		type: Object,
		required: true,
	},
	trashButton: {
		type: Boolean,
		default: true,
	},
	isHistory: {
		type: Boolean,
		default: false,
	},
	showTeams: {
		type: Boolean,
		default: true,
	},
});
</script>

<template>
	<IOrderSubscribeItem 
		v-if="itemCase.type === 'sub'" 
		:item-case="itemCase"
		:trash-button="trashButton"
	/>
	<IOrderEventItem 
		v-else :item-case="itemCase" 
		:trash-button="trashButton"
		:is-history="isHistory"
		:show-teams="showTeams"
	/>
</template>

<style scoped lang="scss"></style>
